import { render, staticRenderFns } from "./BrainInitiative.vue?vue&type=template&id=3ea22556&"
import script from "./BrainInitiative.vue?vue&type=script&lang=js&"
export * from "./BrainInitiative.vue?vue&type=script&lang=js&"
import style0 from "./BrainInitiative.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports